var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirestore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Firestore Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "colored-32/firestore"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,13,12,9v4l9,4Zm0-7L12,2V6l9,4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7",
    className: "cls-2",
    points: "3 6 12 2 12 6 3 10 3 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7-2",
    "data-name": "Rectangle-7",
    className: "cls-2",
    points: "3 13 12 9 12 13 3 17 3 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7-3",
    "data-name": "Rectangle-7",
    className: "cls-3",
    points: "12 18 15.37 16.5 19.88 18.5 12 22 12 18"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirestore);
export default __webpack_public_path__ + "static/media/firestore.a7014b89821d3088c6de50532ef29107.svg";
export { ForwardRef as ReactComponent };